/**
 * 全站 `WebsiteHeader` 公共默认 props。
 * 各页面在 JSX 中先展开本对象，再写页面级属性；后者可覆盖同名键。
 */
export const websiteHeaderDefaults = {
  // 是否显示左侧导航栏
  showLeftNav: false,
  // 是否显示邀请好友入口
  showInviteEntry: false,
  // 是否显示兑换码入口
  showRedeemInviteCodeEntry: false,
  // 是否显示主题切换按钮
  showThemeButton: false,
  // 是否显示语言切换入口
  showLanguageMenu: false
} as const;
